export var GrafanaResultType;
(function (GrafanaResultType) {
    GrafanaResultType["Folder"] = "dash-folder";
    GrafanaResultType["Dashboard"] = "dash-db";
})(GrafanaResultType || (GrafanaResultType = {}));
export class GrafanaAlertResultModel {
    id;
    dashboardId;
    dashboardUid;
    dashboardSlug;
    panelId;
    name;
    state;
    newStateDate;
    evalDate;
    evalData;
    executionError;
    url;
}
//# sourceMappingURL=grafana-alert-result.js.map